var map = {
	"./alzheimers-dementia-news.jpg": 173,
	"./appointments-available-news.jpg": 174,
	"./atagi-covid-news.jpg": 175,
	"./beyond-blue-news.jpg": 176,
	"./blue-september-prostate-cancer-news.jpg": 177,
	"./book-your-flu-shot-news.jpg": 178,
	"./bowel-cancer-news.jpg": 179,
	"./breast-cancer-news.jpg": 180,
	"./cancer-and-covid-19-news.jpg": 181,
	"./cancer-symptoms-trials-news.jpg": 182,
	"./covid-19-covidsafe-news.jpg": 183,
	"./covid-19-isolation-tips-news.jpg": 184,
	"./covid-19-news.jpg": 185,
	"./covid-19-protect-yourself-news.jpg": 186,
	"./covid-19-symptoms-news.jpg": 187,
	"./covid-19-wearing-masks-news.jpg": 188,
	"./covid19-vaccines1-news.jpg": 189,
	"./dr-tharuka2-news.jpg": 190,
	"./endometriosis-concern-news.jpg": 191,
	"./flu-vaccines-news.jpg": 192,
	"./gps-on-vermont-medical-centre-news.jpg": 193,
	"./happy-Anniversary-news.jpg": 194,
	"./heart-attack-symptoms-news.jpg": 195,
	"./heat-stress-news.jpg": 196,
	"./how-are-you-managing-your-mental-health-news.jpg": 197,
	"./life-logo-news.jpg": 198,
	"./lung-cancer-screening-news.jpg": 199,
	"./medicare-news.jpg": 200,
	"./menopause-perimenopause-assessments-news.jpg": 201,
	"./mental-health-news.jpg": 202,
	"./mosquito-template.png": 203,
	"./mymedicare-news.jpg": 204,
	"./nsw-vic-border-closure-news.jpg": 205,
	"./pneumonia-vaccine-news.jpg": 206,
	"./poison-medication-heatwave-news.jpg": 207,
	"./prevent-hpv-cancer-news.jpg": 208,
	"./prostate-check-up-news.jpg": 209,
	"./q-fever-news.jpg": 210,
	"./skin-cancer-news.jpg": 211,
	"./sleep-apnoea-news.jpg": 212,
	"./sleep-deprivation-news.jpg": 213,
	"./stop-vaping-news.jpg": 214,
	"./symptoms-of-menopause-news.jpg": 215,
	"./telehealth-news.jpg": 216,
	"./vaccine-shot-1-news.jpg": 217,
	"./weight-loss-doctor-news.jpg": 218,
	"./winter-vaccines-news.jpg": 219,
	"./xmas-tree-news.jpg": 220,
	"./yellow-fever-news.jpg": 221,
	"./yes-we-are-open-news.jpg": 222
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 172;